import type { ReactNode } from "react"
import { useAuth } from "../contexts/AuthContext"
import { isPlatformUser } from "./platform-roles"

/**
 * Wraps a route subtree and shows an Access Denied view to any caller who is
 * not a platform user (global admin, global ops, trader, etc.). Use to gate the
 * `/admin` backend. Per-section access within `/admin` is enforced separately
 * (see AdminLayout / canAccessAdminSection). Assumes AuthGuard has already
 * verified authentication.
 */
export function RequirePlatformUser({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-content-2">Loading...</div>
      </div>
    )
  }

  if (!isPlatformUser(user?.platformRole)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="mb-2 font-display text-2xl font-bold text-content">Access Denied</h1>
          <p className="text-content-2">You do not have access to this area.</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
